module.exports = __webpack_public_path__ + "static/media/Raghavendra.136dcf55.jpg";